import { View } from 'react-native'

import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      paddingRight: theme.paddingInsetFourpulse,
      paddingLeft: theme.paddingInsetFourpulse,
      paddingBottom: theme.paddingInsetFourpulse,
      paddingTop: theme.spacingStackTwopulse,
      backgroundColor: 'transparent',
    },
    variants: {
      withIcon: {
        true: {
          paddingLeft: theme.paddingInsetTwelvepulse,
        },
      },
      isLink: {
        true: {
          paddingLeft: theme.paddingInsetEightpulse,
          alignSelf: 'flex-start'
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          withIcon: false,
          isLink: true,
        },
        css: {
          paddingLeft: theme.paddingInsetNone,
        },
      },
    ],
  }
})
